import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { OperationType } from 'common/constants/sm-constants';
import { TrainersModel } from 'common/models/page-models/Trainers Model/trainers-data.model';
import { TrainersListingModel } from 'common/models/page-models/Trainers Model/trainers-params.model';
import { RouteEnvelope } from 'common/models/utility-models/base-model';
import { GridParams } from 'common/models/utility-models/list-utility.model';
import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { TrainersGridWidgetService } from 'common/widget/Trainers/trainers-grid-widget.services';


@Injectable({
    providedIn: 'root'
})
export class TrainersGridResolver extends GridResolver<TrainersModel, TrainersListingModel> {
    constructor(
        protected fs: TrainersGridWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }

    override manageState(): RouteEnvelope | { [k: string]: any; } {
        const currentNav = this.router.getCurrentNavigation();
        const extrasState = currentNav ? currentNav.extras.state : undefined;

        if (extrasState === undefined) {
            const envelope = new RouteEnvelope();
            envelope.type = OperationType.VIEW;
            envelope.transferData = new GridParams();
            return envelope;
        } else {
            // console.log("State found:", extrasState);
            return extrasState;
        }
    }
}